import { Pipe, PipeTransform } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'

@Pipe({
  name: 'followupTooltip',
})
export class FollowupTooltipDirective implements PipeTransform {
  transform(inquiry: Inquiry): string {
    return inquiry.followup ? $localize`Unfollow` : $localize`Follow up`
  }
}

@Pipe({
  name: 'editNotesTooltip',
})
export class EditNotesTooltipDirective implements PipeTransform {
  transform(show: object): string {
    return !!show ? $localize`Click to edit or delete comment` : ''
  }
}
